import React from "react";
import { motion, useTransform, useSpring } from "framer-motion";

const PeranKementerianCard = ({ data, index, length, scrollYProgress }) => {
  const cardsPerRow = 3;
  const itemsInLastRow = length % cardsPerRow || cardsPerRow;
  const isInLastRow = index >= length - itemsInLastRow;

  let colSpan = "col-span-1 sm:col-span-2 lg:col-span-2";

  if (isInLastRow) {
    if (itemsInLastRow === 1) colSpan = "col-span-1 sm:col-span-2 lg:col-span-6";
    else if (itemsInLastRow === 2)
      colSpan = "col-span-1 lg:col-span-3";
  }

  const cardX = useTransform(
    scrollYProgress,
    [0, 0.3 + index * 0.1, 0.5 + index * 0.1, 1],
    ["350%", "0%", "0%", "0%"]
  );
  const smoothCardX = useSpring(cardX, { stiffness: 180, damping: 50 });

  return (
    <motion.div
      className={`sticky flex flex-col justify-end items-end gap-2 md:gap-5 bg-cover bg-center p-3 md:p-5 rounded-2xl h-[146px] sm:h-48 lg:h-60 xl:h-80 overflow-hidden ${colSpan}`}
      style={{ backgroundImage: `url(${data.image})`, x: smoothCardX }}
    >
      <div className="absolute inset-0 bg-[#00000069]" />
      <div className="w-full font-bold text-lg md:text-xl z-10">{data.title}</div>
      <div
        className="w-full font-light text-xs md:text-sm z-10"
        dangerouslySetInnerHTML={{ __html: data.description }}
      />
    </motion.div>
  );
};

export default PeranKementerianCard;
